// Model/language constants for the local transcription tool.
//
// Kept free of any `@xenova/transformers` import on purpose: the page needs
// these lists to render its dropdowns, and pulling them from whisper.js would
// drag the entire ONNX runtime into the main bundle. whisper.js itself is only
// ever loaded inside the worker (or lazily, as a fallback).

export const SAMPLE_RATE = 16000;

// Quantized (int8) ONNX exports. Sizes are the total download, rounded.
export const MODELS = [
  { speed: 5, id: 'Xenova/whisper-tiny.en',  label: 'Tiny (English only)',   size: '~42 MB',  multilingual: false, note: 'Fastest. Good for clear audio.' },
  { speed: 3, id: 'Xenova/whisper-base.en',  label: 'Base (English only)',   size: '~78 MB',  multilingual: false, note: 'Balanced — recommended starting point.' },
  { speed: 1.2, id: 'Xenova/whisper-small.en', label: 'Small (English only)',  size: '~250 MB', multilingual: false, note: 'Most accurate English. Noticeably slower.' },
  { speed: 5, id: 'Xenova/whisper-tiny',     label: 'Tiny (multilingual)',   size: '~42 MB',  multilingual: true,  note: 'Fastest multilingual.' },
  { speed: 3, id: 'Xenova/whisper-base',     label: 'Base (multilingual)',   size: '~80 MB',  multilingual: true,  note: 'Balanced multilingual.' },
  { speed: 1.2, id: 'Xenova/whisper-small',    label: 'Small (multilingual)',  size: '~250 MB', multilingual: true,  note: 'Best non-English accuracy. Slow.' },
];

export const DEFAULT_MODEL = 'Xenova/whisper-base.en';

export function modelInfo(id) {
  return MODELS.find(m => m.id === id) || MODELS[1];
}

// Whisper's own language names, limited to the ones that actually come up here.
export const LANGUAGES = [
  { code: '',           label: 'Auto-detect' },
  { code: 'english',    label: 'English' },
  { code: 'spanish',    label: 'Spanish' },
  { code: 'portuguese', label: 'Portuguese' },
  { code: 'french',     label: 'French' },
  { code: 'haitian creole', label: 'Haitian Creole' },
  { code: 'italian',    label: 'Italian' },
  { code: 'german',     label: 'German' },
  { code: 'polish',     label: 'Polish' },
  { code: 'russian',    label: 'Russian' },
  { code: 'ukrainian',  label: 'Ukrainian' },
  { code: 'albanian',   label: 'Albanian' },
  { code: 'arabic',     label: 'Arabic' },
  { code: 'hebrew',     label: 'Hebrew' },
  { code: 'turkish',    label: 'Turkish' },
  { code: 'chinese',    label: 'Chinese' },
  { code: 'korean',     label: 'Korean' },
  { code: 'japanese',   label: 'Japanese' },
  { code: 'vietnamese', label: 'Vietnamese' },
  { code: 'hindi',      label: 'Hindi' },
  { code: 'urdu',       label: 'Urdu' },
  { code: 'bengali',    label: 'Bengali' },
  { code: 'tagalog',    label: 'Tagalog' },
];
